import React from 'react';
import { Container, Row, Col } from 'reactstrap'
import {moduleName} from 'react-router-dom'

export default () => {
  return (
    <Container fluid>
      <div className="d-flex full-height p-v-20 flex-column justify-content-between">
        <div className="d-none d-md-flex p-h-40">
          <img src={require("../../assets/img/myh-logo.png")} height="65px" alt="" />
        </div>
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="p-v-30">
                <h1 className="font-weight-semibold display-1 text-primary lh-1-2">404</h1>
                <h2 class="font-weight-light font-size-30">Whoops! Looks like you got lost</h2>
                <p class="lead m-b-30">We couldnt find what you were looking for.</p>
                <a href="" class="btn btn-primary btn-tone">Go Back</a>
              </div>
            </Col>
            <Col md={6} className="m-l-auto">
              <img class="img-fluid" src={require('../../assets/img/error.png')} alt="" />
            </Col>
          </Row>
          <div class="d-none d-md-flex  p-h-40 justify-content-between">
            <span class="">© 2019 HungHau Holdings</span>
            <ul class="list-inline">
              <li class="list-inline-item">
                <a class="text-dark text-link" href="">Legal</a>
              </li>
              <li class="list-inline-item">
                <a class="text-dark text-link" href="">Privacy</a>
              </li>
            </ul>
          </div>
        </Container>
      </div>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/not-found/NotFound.js